import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // initiera språkstöd före App (synkron init, inga suspense-hål)
import App from './App';
import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
